import styled from "@emotion/styled";
import React from "react";

const Spinner = React.forwardRef<SVGSVGElement, React.SVGProps<SVGSVGElement>>(
  (props, svgRef) => {
    return (
      <svg ref={svgRef} viewBox="0 0 400 400" {...props}>
        <g id="loading-innercircle_1_">
          <path
            className="st0"
            d="M326.8 159.2c-.6.6-1.3 1-2.1 1.3l-46.2 17.3c-.8.3-1.6.5-2.5.5-3.5 0-6.3-2.8-6.3-6.3 0-2.6 1.6-4.9 3.9-5.8l46.6-17.5c.8-.3 1.6-.4 2.4-.4.8 0 1.6.2 2.4.6.8.3 1.4.8 2 1.4.6.6 1 1.3 1.3 2.1.3.8.4 1.6.4 2.4 0 .8-.2 1.6-.6 2.4-.2.8-.7 1.5-1.3 2zM317.5 137.8c-.5.7-1.1 1.2-1.8 1.6l-42.3 25.1c-1 .6-2.1 1-3.4 1-3.5 0-6.3-2.8-6.3-6.3 0-2.2 1.1-4.1 2.8-5.2l42.6-25.4c1.4-.8 3.1-1.1 4.8-.7 1.6.4 3 1.4 3.9 2.9.4.7.7 1.5.8 2.3.1.8.1 1.7-.1 2.5s-.5 1.5-1 2.2zM305.7 116c-.1 1.7-.9 3.2-2.2 4.3l-37 31.7c-1.1 1.2-2.8 2-4.6 2-3.5 0-6.3-2.8-6.3-6.3 0-2.1 1-3.9 2.6-5.1l37.2-31.9c1.3-1.1 2.9-1.6 4.6-1.5 1.7.1 3.2.9 4.3 2.2 1 1.3 1.5 2.9 1.4 4.6zM289.5 101.4c-.2.8-.6 1.5-1.2 2.2l-31.2 37.7c-1.1 1.7-3 2.8-5.2 2.8-3.5 0-6.3-2.8-6.3-6.3 0-1.7.7-3.2 1.7-4.3l31.3-38c.5-.6 1.2-1.2 1.9-1.6.7-.4 1.5-.6 2.4-.7s1.7 0 2.4.2c.8.2 1.5.6 2.2 1.2.6.5 1.2 1.2 1.6 1.9.4.7.6 1.5.7 2.4 0 .9 0 1.7-.3 2.5zM271.1 87.3c-.1.9-.5 1.7-.9 2.4l-24.3 42.8c-1 2-3.2 3.5-5.6 3.5-3.5 0-6.3-2.8-6.3-6.3 0-1.3.4-2.5 1.1-3.5l24.2-43.1c.4-.7.9-1.4 1.6-1.9.6-.5 1.4-.9 2.2-1.1.8-.2 1.6-.3 2.4-.2.8.1 1.6.3 2.3.8.8.4 1.5 1 2 1.7s.9 1.5 1.2 2.3c.2.8.3 1.7.1 2.6zM249.5 74.6c.7 1.5.8 3.2.3 4.8l-16.3 46.2c-.8 2.6-3.2 4.5-6 4.5-3.5 0-6.3-2.8-6.3-6.3 0-1 .2-1.9.6-2.8l16.1-45.8c.5-1.6 1.7-2.9 3.2-3.6 1.5-.7 3.2-.8 4.8-.3 1.6.6 2.9 1.8 3.6 3.3zM227 67.7c1 1.4 1.3 3.1 1.1 4.7l-8 48.3c-.3 3.2-3 5.7-6.2 5.7-3.5 0-6.3-2.8-6.3-6.3v-.7l8.1-49.2c.3-1.7 1.2-3.1 2.6-4.1 1.4-1 3.1-1.3 4.7-1.1 1.6.4 3.1 1.4 4 2.7zM203.6 65c1.2 1.2 1.8 2.8 1.8 4.4l.5 49.3v.6c-.1 3.3-2.9 6-6.3 6s-6.1-2.7-6.3-6l-.5-49.8c0-1.7.7-3.3 1.8-4.4 1.2-1.2 2.8-1.8 4.4-1.8 1.8-.1 3.4.5 4.6 1.7zM180.1 66.2c1.4.9 2.3 2.4 2.6 4l9 48.2c.2.6.3 1.2.3 1.8 0 3.5-2.8 6.3-6.3 6.3-3.1 0-5.7-2.3-6.2-5.3l-9.1-48.8c-.3-1.6.1-3.3 1-4.7.9-1.4 2.4-2.3 4-2.6 1.6-.2 3.3.2 4.7 1.1zM157.2 71.9c1.5.7 2.7 2 3.3 3.5l17.2 45.9c.4.8.6 1.7.6 2.7 0 3.5-2.8 6.3-6.3 6.3-2.6 0-4.8-1.5-5.7-3.8l-17.6-46.6c-.6-1.6-.5-3.3.2-4.8s2-2.7 3.5-3.3c1.6-.6 3.3-.6 4.8.1zM135.6 81.4c1.6.4 3 1.5 3.8 2.9l25.2 42.4c.6 1 1 2.1 1 3.3 0 3.5-2.8 6.3-6.3 6.3-2.2 0-4.1-1.1-5.2-2.7l-25.4-42.5c-.5-.7-.8-1.6-1-2.4-.1-.9-.1-1.8.1-2.6.2-.9.6-1.7 1.1-2.4.5-.7 1.2-1.3 2-1.7 1.4-.8 3.1-1.1 4.7-.6zM118.3 94.8c.8.4 1.4 1 2 1.6l31.9 37.9c1.2 1.1 1.9 2.7 1.9 4.5 0 3.5-2.8 6.3-6.3 6.3-1.9 0-3.6-.9-4.8-2.2l-32.6-38c-.6-.6-1-1.4-1.3-2.2-.3-.8-.4-1.7-.3-2.5.1-.8.3-1.7.7-2.4.4-.8.9-1.4 1.6-2 .6-.6 1.4-1 2.2-1.3.8-.3 1.7-.4 2.5-.3.9 0 1.8.2 2.5.6zM101.4 110.8c.8.2 1.5.6 2.2 1.2l38 31.4c1.6 1.1 2.6 3 2.6 5.1 0 3.5-2.8 6.3-6.3 6.3-1.6 0-3-.6-4.1-1.5l-38.2-31.5c-.6-.5-1.2-1.2-1.6-1.9-.4-.7-.6-1.5-.7-2.4-.1-.8 0-1.7.2-2.4.2-.8.6-1.5 1.2-2.2.5-.6 1.2-1.2 1.9-1.6.7-.4 1.5-.6 2.4-.7.8-.2 1.6-.1 2.4.2zM87.3 129.1c.9.1 1.7.5 2.4.9l42.9 24.9c1.7 1.1 2.8 3.1 2.8 5.2 0 3.5-2.8 6.3-6.3 6.3-.9 0-1.8-.2-2.6-.6L83 141.3c-.8-.4-1.5-1-2-1.7s-1-1.5-1.2-2.3c-.2-.9-.3-1.7-.2-2.6.1-.9.4-1.7.9-2.5.4-.8 1-1.5 1.7-2s1.5-.9 2.3-1.2c1 0 1.9-.1 2.8.1zM74.4 150.5c1.5-.7 3.2-.8 4.8-.3l47 16.6c2.2 1 3.8 3.2 3.8 5.8 0 3.5-2.8 6.3-6.3 6.3-.9 0-1.8-.2-2.6-.6L75 162.1c-1.6-.6-2.9-1.7-3.6-3.2-.7-1.5-.8-3.2-.3-4.8.7-1.6 1.8-2.9 3.3-3.6zM70 172c.8-.2 1.6-.2 2.5 0l49.2 8c2.8.6 4.9 3.1 4.9 6.1 0 3.5-2.8 6.3-6.3 6.3h-.8l-49.3-8.1c-.8-.1-1.6-.5-2.3-.9-.7-.4-1.3-1-1.8-1.7s-.8-1.4-1-2.3c-.2-.8-.2-1.6 0-2.5.1-.8.5-1.6.9-2.3.4-.7 1-1.3 1.7-1.8.7-.3 1.5-.6 2.3-.8zM65 196.4c1.2-1.2 2.8-1.8 4.4-1.8l49.2-.5h.8c3.3.2 5.8 2.9 5.8 6.3 0 3.3-2.5 5.9-5.7 6.2h-1l-49.2.6c-1.7 0-3.3-.7-4.4-1.8-1.2-1.2-1.8-2.8-1.8-4.4.1-1.8.7-3.4 1.9-4.6zM121.5 220.5c2.9-.5 5.2-3.1 5.2-6.2 0-3.5-2.8-6.3-6.3-6.3-.4 0-.8 0-1.2.1l-49 9.1c-1.6.3-3.1 1.2-4 2.6-.9 1.4-1.3 3.1-1 4.7.3 1.6 1.2 3.1 2.6 4 1.4.9 3.1 1.3 4.7 1l49-9zM125.7 234.2c2.7-.7 4.8-3.1 4.8-6.1 0-3.5-2.8-6.3-6.3-6.3-.7 0-1.4.1-2 .3l-46.7 17.4c-1.6.6-2.8 1.8-3.5 3.3-.7 1.5-.7 3.2-.1 4.8.3.8.7 1.5 1.3 2.1.6.6 1.2 1.1 2 1.4.8.3 1.6.5 2.4.5.8 0 1.6-.1 2.4-.4l45.7-17zM133.7 246.2c1.7-1.1 2.9-3.1 2.9-5.3 0-3.5-2.8-6.3-6.3-6.3-1.4 0-2.6.4-3.6 1.2l-42.4 24.8c-.8.4-1.5 1-2 1.7s-.9 1.5-1.1 2.4c-.2.9-.2 1.7-.1 2.6.1.9.5 1.7 1 2.4.4.7 1 1.3 1.6 1.8s1.4.9 2.2 1.1 1.6.2 2.5.1c.8-.1 1.6-.4 2.3-.8l43-25.7zM134.7 247.3c-.3.2-.6.5-.9.7l-37.3 31.3c-1.3 1.1-2 2.6-2.2 4.3-.1 1.7.4 3.3 1.5 4.6 1.1 1.3 2.6 2 4.3 2.2 1.7.1 3.3-.4 4.6-1.5l38-31.9c1.2-1.1 1.9-2.7 1.9-4.5 0-3.5-2.8-6.3-6.3-6.3-1.3 0-2.6.4-3.6 1.1zM152.7 267.1c1.3-1.1 2.1-2.8 2.1-4.6 0-3.5-2.8-6.3-6.3-6.3-2.1 0-4 1.1-5.2 2.7l-31.4 37.5c-.5.7-1 1.4-1.2 2.2-.3.8-.3 1.7-.3 2.5.1.8.3 1.7.7 2.4.4.7 1 1.4 1.6 1.9.6.6 1.4 1 2.2 1.2.8.3 1.7.4 2.5.3.9-.1 1.7-.3 2.4-.8.7-.4 1.4-1 1.9-1.7l31-37.3zM165.4 273c.4-.8.6-1.7.6-2.7 0-3.5-2.8-6.3-6.3-6.3-2.6 0-4.8 1.5-5.7 3.7l-24 42.6c-.8 1.5-1 3.2-.5 4.8.5 1.6 1.5 3 3 3.8 1.5.8 3.2 1 4.8.5 1.6-.5 3-1.5 3.8-3l24.3-43.4zM178.5 278.2c.2-.6.3-1.3.3-2 0-3.5-2.8-6.3-6.3-6.3-2.7 0-4.9 1.7-5.9 4l-16.4 46.9c-.5 1.5-.3 3.2.4 4.7s2 2.6 3.5 3.1 3.2.5 4.7-.2 2.6-1.9 3.2-3.4l16.5-46.8zM192.4 280.4v-.6c0-3.5-2.8-6.3-6.3-6.3-3.4 0-6.1 2.6-6.3 6l-7.9 48.1c-.2 1.6.3 3.2 1.3 4.5 1 1.3 2.4 2.1 4 2.4 1.6.3 3.2-.1 4.5-1 1.3-.9 2.3-2.3 2.6-3.8l8.1-49.3zM194 280.8v.5l.5 49.2c0 1.7.7 3.3 1.9 4.4 1.2 1.2 2.8 1.8 4.5 1.8 1.7 0 3.3-.7 4.4-2 1.2-1.2 1.8-2.8 1.8-4.5l-.6-49.8c-.2-3.3-2.9-5.8-6.3-5.8-3.3 0-6 2.6-6.3 5.8l.1.4zM208.6 282.1l8.7 47.4a6.2 6.2 0 002.7 4c1.4.9 3.1 1.3 4.7 1 .8-.1 1.6-.4 2.3-.9.7-.4 1.3-1 1.8-1.7s.8-1.5 1-2.3c.2-.8.2-1.7 0-2.5l-9.1-49h-.1c-.7-2.7-3.1-4.7-6.1-4.7-3.5 0-6.3 2.8-6.3 6.3-.1.9.1 1.7.4 2.4zM222.2 278.5l17.3 46.3c.3.8.7 1.5 1.3 2.1.6.6 1.2 1.1 2 1.4.8.3 1.6.5 2.4.6.8 0 1.7-.1 2.4-.4.8-.3 1.5-.7 2.1-1.3.6-.6 1.1-1.3 1.4-2 .3-.8.5-1.6.5-2.4 0-.8-.1-1.7-.4-2.4L234 274.2c-.8-2.6-3.2-4.4-6-4.4-3.5 0-6.3 2.8-6.3 6.3 0 .8.2 1.6.5 2.4zM245.9 266.5c-1.1-1.7-3-2.8-5.2-2.8-3.5 0-6.3 2.8-6.3 6.3 0 1.2.3 2.3.9 3.3l25.2 42.4c.4.7 1 1.3 1.6 1.8.7.5 1.4.9 2.2 1.1s1.6.2 2.5.1c.8-.1 1.6-.4 2.3-.8.7-.4 1.3-1 1.8-1.6.5-.7.9-1.4 1.1-2.2.2-.8.2-1.6.1-2.5-.1-.8-.4-1.6-.8-2.3l-25.4-42.8zM256.8 257.6c-1.1-1.2-2.7-1.9-4.5-1.9-3.5 0-6.3 2.8-6.3 6.3 0 1.8.8 3.5 2.1 4.6l31.7 37c.5.6 1.2 1.2 2 1.6.8.4 1.6.6 2.4.7.8.1 1.7-.1 2.5-.3.8-.3 1.5-.7 2.2-1.3.7-.5 1.2-1.2 1.6-2 .4-.8.6-1.6.7-2.4.1-.9-.1-1.7-.3-2.5-.3-.8-.7-1.5-1.3-2.2l-32.8-37.6zM266.5 247.4c-1.1-1.1-2.7-1.7-4.3-1.7-3.5 0-6.3 2.8-6.3 6.3 0 1.8.8 3.5 2 4.6l38.6 31.9c.6.6 1.4 1 2.2 1.3.8.3 1.7.4 2.5.3.9-.1 1.7-.3 2.4-.7.8-.4 1.4-1 1.9-1.7s1-1.4 1.2-2.2c.3-.8.3-1.7.3-2.5-.1-.8-.3-1.7-.7-2.4-.4-.7-1-1.4-1.6-1.9l-38.2-31.3zM267.3 245.8l43.1 24.5c1.4.8 3.2 1 4.8.6 1.6-.4 3-1.5 3.8-3 .8-1.5 1-3.2.6-4.8-.4-1.6-1.5-3-3-3.8l-42.5-24c-1.1-.8-2.4-1.3-3.8-1.3-3.5 0-6.3 2.8-6.3 6.3 0 2.2 1.1 4.1 2.8 5.2l.3.2s.1 0 .2.1zM279 221.8c-.8-.4-1.8-.6-2.8-.6-3.5 0-6.3 2.8-6.3 6.3 0 3 2.1 5.5 4.8 6.1l46.1 16.3c1.6.4 3.2.3 4.7-.5 1.4-.8 2.5-2 3-3.6.5-1.5.4-3.2-.3-4.7s-1.9-2.6-3.4-3.2L279 221.8zM330.2 228.1c-.8.2-1.7.1-2.5 0l-49.4-8.2c-2.7-.7-4.7-3.2-4.7-6.1 0-3.5 2.8-6.3 6.3-6.3h.8c.2 0 .4.1.6.1l48.5 8c.8.1 1.7.3 2.4.8.7.4 1.4 1 1.9 1.7s.9 1.5 1.1 2.3c.2.8.2 1.7.1 2.5s-.4 1.7-.9 2.4-1.1 1.3-1.8 1.8c-.8.5-1.6.9-2.4 1zM335 203.6c-1.2 1.2-2.8 1.8-4.4 1.8l-49.2.5h-.7c-3.3-.2-5.9-2.9-5.9-6.3 0-3.3 2.6-6.1 5.9-6.3l49.9-.5c1.7 0 3.3.7 4.4 1.8 1.2 1.2 1.8 2.8 1.8 4.4 0 1.8-.6 3.4-1.8 4.6zM333.6 180.1c-.9 1.4-2.4 2.3-4.1 2.7l-48.4 9.1c-.2 0-.3.1-.5.1H279.7c-3.5 0-6.3-2.8-6.3-6.3 0-2.8 1.9-5.2 4.5-6h.2c.3-.1.6-.1.9-.2l48.2-9.2c1.7-.3 3.4 0 4.7 1 1.4.9 2.3 2.4 2.7 4.1.3 1.6-.1 3.3-1 4.7z"
          />
        </g>
        <g id="loading-outer1">
          <path
            className="st1"
            d="M337.8 155c3.5 0 6.3-2.8 6.3-6.3s-2.8-6.3-6.3-6.3-6.3 2.8-6.3 6.3 2.8 6.3 6.3 6.3z"
          />
          <path
            className="st2"
            d="M326.8 131.9c3.5 0 6.3-2.8 6.3-6.3s-2.8-6.3-6.3-6.3-6.3 2.8-6.3 6.3 2.8 6.3 6.3 6.3z"
          />
          <path
            className="st1"
            d="M311.9 111c3.5 0 6.3-2.8 6.3-6.3s-2.8-6.3-6.3-6.3-6.3 2.8-6.3 6.3 2.8 6.3 6.3 6.3z"
          />
          <path
            className="st2"
            d="M293.7 93c3.5 0 6.3-2.8 6.3-6.3s-2.8-6.3-6.3-6.3-6.3 2.8-6.3 6.3 2.8 6.3 6.3 6.3z"
          />
          <path
            className="st1"
            d="M272.6 78.5c3.5 0 6.3-2.8 6.3-6.3s-2.8-6.3-6.3-6.3-6.3 2.8-6.3 6.3 2.8 6.3 6.3 6.3z"
          />
          <path
            className="st2"
            d="M249.3 67.8c3.5 0 6.3-2.8 6.3-6.3s-2.8-6.3-6.3-6.3-6.3 2.8-6.3 6.3 2.9 6.3 6.3 6.3z"
          />
          <path
            className="st1"
            d="M224.5 61.3c3.5 0 6.3-2.8 6.3-6.3s-2.8-6.3-6.3-6.3-6.3 2.8-6.3 6.3 2.8 6.3 6.3 6.3z"
          />
          <path
            className="st2"
            d="M199 59.3c3.5 0 6.3-2.8 6.3-6.3s-2.8-6.3-6.3-6.3-6.3 2.8-6.3 6.3 2.8 6.3 6.3 6.3z"
          />
          <path
            className="st1"
            d="M173.5 61.7c3.5 0 6.3-2.8 6.3-6.3s-2.8-6.3-6.3-6.3-6.3 2.8-6.3 6.3 2.8 6.3 6.3 6.3z"
          />
          <path
            className="st2"
            d="M148.8 68.5c3.5 0 6.3-2.8 6.3-6.3s-2.8-6.3-6.3-6.3-6.3 2.8-6.3 6.3 2.8 6.3 6.3 6.3z"
          />
          <path
            className="st1"
            d="M125.6 79.5c3.5 0 6.3-2.8 6.3-6.3s-2.8-6.3-6.3-6.3-6.3 2.8-6.3 6.3 2.8 6.3 6.3 6.3z"
          />
          <path
            className="st2"
            d="M104.8 94.3c3.5 0 6.3-2.8 6.3-6.3s-2.8-6.3-6.3-6.3-6.3 2.8-6.3 6.3 2.8 6.3 6.3 6.3z"
          />
          <path
            className="st1"
            d="M86.8 112.6c3.5 0 6.3-2.8 6.3-6.3s-2.8-6.3-6.3-6.3-6.3 2.8-6.3 6.3 2.8 6.3 6.3 6.3z"
          />
          <path
            className="st2"
            d="M72.2 133.7c3.5 0 6.3-2.8 6.3-6.3s-2.8-6.3-6.3-6.3-6.3 2.8-6.3 6.3c.1 3.5 2.9 6.3 6.3 6.3z"
          />
          <path
            className="st1"
            d="M61.5 157c3.5 0 6.3-2.8 6.3-6.3s-2.8-6.3-6.3-6.3-6.3 2.8-6.3 6.3c0 3.4 2.8 6.3 6.3 6.3z"
          />
          <path
            className="st2"
            d="M55 181.7c3.5 0 6.3-2.8 6.3-6.3s-2.8-6.3-6.3-6.3-6.3 2.8-6.3 6.3c.1 3.5 2.9 6.3 6.3 6.3z"
          />
          <path
            className="st1"
            d="M53 207.2c3.5 0 6.3-2.8 6.3-6.3s-2.8-6.3-6.3-6.3-6.3 2.8-6.3 6.3c.1 3.5 2.9 6.3 6.3 6.3z"
          />
          <path
            className="st2"
            d="M55.4 232.8c3.5 0 6.3-2.8 6.3-6.3s-2.8-6.3-6.3-6.3-6.3 2.8-6.3 6.3 2.8 6.3 6.3 6.3z"
          />
          <path
            className="st1"
            d="M62.2 257.5c3.5 0 6.3-2.8 6.3-6.3s-2.8-6.3-6.3-6.3-6.3 2.8-6.3 6.3c.1 3.5 2.9 6.3 6.3 6.3z"
          />
          <path
            className="st2"
            d="M73.2 280.6c3.5 0 6.3-2.8 6.3-6.3s-2.8-6.3-6.3-6.3-6.3 2.8-6.3 6.3c.1 3.5 2.9 6.3 6.3 6.3z"
          />
          <path
            className="st1"
            d="M88 301.5c3.5 0 6.3-2.8 6.3-6.3s-2.8-6.3-6.3-6.3-6.3 2.8-6.3 6.3c.1 3.5 2.9 6.3 6.3 6.3z"
          />
          <path
            className="st2"
            d="M106.3 319.5c3.5 0 6.3-2.8 6.3-6.3s-2.8-6.3-6.3-6.3-6.3 2.8-6.3 6.3 2.9 6.3 6.3 6.3z"
          />
          <path
            className="st1"
            d="M127.4 334c3.5 0 6.3-2.8 6.3-6.3s-2.8-6.3-6.3-6.3-6.3 2.8-6.3 6.3 2.8 6.3 6.3 6.3z"
          />
          <path
            className="st2"
            d="M150.7 344.7c3.5 0 6.3-2.8 6.3-6.3s-2.8-6.3-6.3-6.3-6.3 2.8-6.3 6.3 2.8 6.3 6.3 6.3z"
          />
          <path
            className="st1"
            d="M175.5 351.1c3.5 0 6.3-2.8 6.3-6.3s-2.8-6.3-6.3-6.3-6.3 2.8-6.3 6.3 2.8 6.3 6.3 6.3z"
          />
          <path
            className="st2"
            d="M201 353.2c3.5 0 6.3-2.8 6.3-6.3s-2.8-6.3-6.3-6.3-6.3 2.8-6.3 6.3 2.8 6.3 6.3 6.3z"
          />
          <path
            className="st1"
            d="M226.5 350.8c3.5 0 6.3-2.8 6.3-6.3s-2.8-6.3-6.3-6.3-6.3 2.8-6.3 6.3 2.8 6.3 6.3 6.3z"
          />
          <path
            className="st2"
            d="M251.2 344c3.5 0 6.3-2.8 6.3-6.3s-2.8-6.3-6.3-6.3-6.3 2.8-6.3 6.3c.1 3.4 2.9 6.3 6.3 6.3z"
          />
          <path
            className="st1"
            d="M274.3 333c3.5 0 6.3-2.8 6.3-6.3s-2.8-6.3-6.3-6.3-6.3 2.8-6.3 6.3 2.9 6.3 6.3 6.3z"
          />
          <path
            className="st2"
            d="M295.2 318.1c3.5 0 6.3-2.8 6.3-6.3s-2.8-6.3-6.3-6.3-6.3 2.8-6.3 6.3c.1 3.5 2.9 6.3 6.3 6.3z"
          />
          <path
            className="st1"
            d="M313.2 300c3.5 0 6.3-2.8 6.3-6.3s-2.8-6.3-6.3-6.3-6.3 2.8-6.3 6.3c.1 3.4 2.9 6.3 6.3 6.3z"
          />
          <path
            className="st2"
            d="M327.8 278.9c3.5 0 6.3-2.8 6.3-6.3s-2.8-6.3-6.3-6.3-6.3 2.8-6.3 6.3 2.8 6.3 6.3 6.3z"
          />
          <path
            className="st1"
            d="M338.4 255.6c3.5 0 6.3-2.8 6.3-6.3s-2.8-6.3-6.3-6.3-6.3 2.8-6.3 6.3 2.8 6.3 6.3 6.3z"
          />
          <path
            className="st2"
            d="M344.9 230.8c3.5 0 6.3-2.8 6.3-6.3s-2.8-6.3-6.3-6.3-6.3 2.8-6.3 6.3 2.8 6.3 6.3 6.3z"
          />
          <path
            className="st1"
            d="M347 205.2c3.5 0 6.3-2.8 6.3-6.3s-2.8-6.3-6.3-6.3-6.3 2.8-6.3 6.3 2.8 6.3 6.3 6.3z"
          />
          <path
            className="st2"
            d="M344.5 179.7c3.5 0 6.3-2.8 6.3-6.3s-2.8-6.3-6.3-6.3-6.3 2.8-6.3 6.3 2.8 6.3 6.3 6.3z"
          />
        </g>
        <g id="loading-outer2">
          <path
            className="st3"
            d="M353.2 149.3c3.5 0 6.3-2.8 6.3-6.3s-2.8-6.3-6.3-6.3-6.3 2.8-6.3 6.3 2.8 6.3 6.3 6.3zM341 123.5c3.5 0 6.3-2.8 6.3-6.3s-2.8-6.3-6.3-6.3-6.3 2.8-6.3 6.3 2.8 6.3 6.3 6.3zM324.5 100.3c3.5 0 6.3-2.8 6.3-6.3s-2.8-6.3-6.3-6.3-6.3 2.8-6.3 6.3 2.8 6.3 6.3 6.3zM304.2 80.3c3.5 0 6.3-2.8 6.3-6.3s-2.8-6.3-6.3-6.3-6.3 2.8-6.3 6.3 2.8 6.3 6.3 6.3zM280.7 64.1c3.5 0 6.3-2.8 6.3-6.3s-2.8-6.3-6.3-6.3-6.3 2.8-6.3 6.3 2.9 6.3 6.3 6.3zM254.8 52.3c3.5 0 6.3-2.8 6.3-6.3s-2.8-6.3-6.3-6.3-6.3 2.8-6.3 6.3 2.9 6.3 6.3 6.3zM227.2 45.1c3.5 0 6.3-2.8 6.3-6.3s-2.8-6.3-6.3-6.3-6.3 2.8-6.3 6.3 2.8 6.3 6.3 6.3zM198.8 42.8c3.5 0 6.3-2.8 6.3-6.3s-2.8-6.3-6.3-6.3-6.3 2.8-6.3 6.3 2.9 6.3 6.3 6.3zM170.5 45.5c3.5 0 6.3-2.8 6.3-6.3s-2.8-6.3-6.3-6.3-6.3 2.8-6.3 6.3 2.8 6.3 6.3 6.3zM143 53.1c3.5 0 6.3-2.8 6.3-6.3s-2.8-6.3-6.3-6.3-6.3 2.8-6.3 6.3 2.8 6.3 6.3 6.3zM117.3 65.4c3.5 0 6.3-2.8 6.3-6.3s-2.8-6.3-6.3-6.3-6.3 2.8-6.3 6.3 2.8 6.3 6.3 6.3zM94 81.8c3.5 0 6.3-2.8 6.3-6.3s-2.8-6.3-6.3-6.3-6.3 2.8-6.3 6.3 2.8 6.3 6.3 6.3zM74 102.2c3.5 0 6.3-2.8 6.3-6.3s-2.8-6.3-6.3-6.3-6.3 2.8-6.3 6.3 2.8 6.3 6.3 6.3zM57.9 125.6c3.5 0 6.3-2.8 6.3-6.3s-2.8-6.3-6.3-6.3-6.3 2.8-6.3 6.3 2.8 6.3 6.3 6.3zM46 151.5c3.5 0 6.3-2.8 6.3-6.3s-2.8-6.3-6.3-6.3-6.3 2.8-6.3 6.3 2.8 6.3 6.3 6.3zM38.8 179.1c3.5 0 6.3-2.8 6.3-6.3s-2.8-6.3-6.3-6.3-6.3 2.8-6.3 6.3 2.9 6.3 6.3 6.3zM36.5 207.5c3.5 0 6.3-2.8 6.3-6.3s-2.8-6.3-6.3-6.3-6.3 2.8-6.3 6.3c.1 3.4 2.9 6.3 6.3 6.3zM39.3 235.8c3.5 0 6.3-2.8 6.3-6.3s-2.8-6.3-6.3-6.3-6.3 2.8-6.3 6.3 2.8 6.3 6.3 6.3zM46.8 263.4c3.5 0 6.3-2.8 6.3-6.3s-2.8-6.3-6.3-6.3-6.3 2.8-6.3 6.3 2.9 6.3 6.3 6.3zM59.1 289.1c3.5 0 6.3-2.8 6.3-6.3s-2.8-6.3-6.3-6.3-6.3 2.8-6.3 6.3 2.8 6.3 6.3 6.3zM75.5 312.3c3.5 0 6.3-2.8 6.3-6.3s-2.8-6.3-6.3-6.3-6.3 2.8-6.3 6.3c.1 3.5 2.9 6.3 6.3 6.3zM95.9 332.3c3.5 0 6.3-2.8 6.3-6.3s-2.8-6.3-6.3-6.3-6.3 2.8-6.3 6.3 2.8 6.3 6.3 6.3zM119.4 348.5c3.5 0 6.3-2.8 6.3-6.3s-2.8-6.3-6.3-6.3-6.3 2.8-6.3 6.3c0 3.4 2.8 6.3 6.3 6.3zM145.3 360.3c3.5 0 6.3-2.8 6.3-6.3s-2.8-6.3-6.3-6.3-6.3 2.8-6.3 6.3 2.8 6.3 6.3 6.3zM172.8 367.5c3.5 0 6.3-2.8 6.3-6.3s-2.8-6.3-6.3-6.3-6.3 2.8-6.3 6.3c0 3.4 2.9 6.3 6.3 6.3zM201.2 369.7c3.5 0 6.3-2.8 6.3-6.3s-2.8-6.3-6.3-6.3-6.3 2.8-6.3 6.3 2.8 6.3 6.3 6.3zM229.5 367.1c3.5 0 6.3-2.8 6.3-6.3s-2.8-6.3-6.3-6.3-6.3 2.8-6.3 6.3c.1 3.5 2.9 6.3 6.3 6.3zM257.1 359.5c3.5 0 6.3-2.8 6.3-6.3s-2.8-6.3-6.3-6.3-6.3 2.8-6.3 6.3c0 3.4 2.8 6.3 6.3 6.3zM282.8 347.3c3.5 0 6.3-2.8 6.3-6.3s-2.8-6.3-6.3-6.3-6.3 2.8-6.3 6.3 2.9 6.3 6.3 6.3zM306 330.7c3.5 0 6.3-2.8 6.3-6.3s-2.8-6.3-6.3-6.3-6.3 2.8-6.3 6.3 2.8 6.3 6.3 6.3zM326 310.5c3.5 0 6.3-2.8 6.3-6.3s-2.8-6.3-6.3-6.3-6.3 2.8-6.3 6.3c0 3.4 2.8 6.3 6.3 6.3zM342.2 287c3.5 0 6.3-2.8 6.3-6.3s-2.8-6.3-6.3-6.3-6.3 2.8-6.3 6.3 2.8 6.3 6.3 6.3zM354 261.1c3.5 0 6.3-2.8 6.3-6.3s-2.8-6.3-6.3-6.3-6.3 2.8-6.3 6.3 2.8 6.3 6.3 6.3zM361.2 233.5c3.5 0 6.3-2.8 6.3-6.3s-2.8-6.3-6.3-6.3-6.3 2.8-6.3 6.3c0 3.4 2.8 6.3 6.3 6.3zM363.5 205.1c3.5 0 6.3-2.8 6.3-6.3s-2.8-6.3-6.3-6.3-6.3 2.8-6.3 6.3 2.8 6.3 6.3 6.3zM360.8 176.7c3.5 0 6.3-2.8 6.3-6.3s-2.8-6.3-6.3-6.3-6.3 2.8-6.3 6.3 2.9 6.3 6.3 6.3z"
          />
        </g>
        <g id="loading-outer3">
          <path
            className="st4"
            d="M368.6 144.7c3.5 0 6.3-2.8 6.3-6.3s-2.8-6.3-6.3-6.3-6.3 2.8-6.3 6.3 2.8 6.3 6.3 6.3zM337 90.8c3.5 0 6.3-2.8 6.3-6.3s-2.8-6.3-6.3-6.3-6.3 2.8-6.3 6.3 2.8 6.3 6.3 6.3zM314.6 68.8c3.5 0 6.3-2.8 6.3-6.3s-2.8-6.3-6.3-6.3-6.3 2.8-6.3 6.3 2.8 6.3 6.3 6.3zM288.8 51c3.5 0 6.3-2.8 6.3-6.3s-2.8-6.3-6.3-6.3-6.3 2.8-6.3 6.3c0 3.4 2.8 6.3 6.3 6.3zM229.9 30c3.5 0 6.3-2.8 6.3-6.3s-2.8-6.3-6.3-6.3-6.3 2.8-6.3 6.3 2.8 6.3 6.3 6.3zM198.6 27.6c3.5 0 6.3-2.8 6.3-6.3s-2.8-6.3-6.3-6.3-6.3 2.8-6.3 6.3 2.8 6.3 6.3 6.3zM167.3 30.5c3.5 0 6.3-2.8 6.3-6.3s-2.8-6.3-6.3-6.3-6.3 2.8-6.3 6.3 2.9 6.3 6.3 6.3zM108.8 52.4c3.5 0 6.3-2.8 6.3-6.3s-2.8-6.3-6.3-6.3-6.3 2.8-6.3 6.3 2.8 6.3 6.3 6.3zM83.2 70.6c3.5 0 6.3-2.8 6.3-6.3S86.7 58 83.2 58s-6.3 2.8-6.3 6.3c.1 3.5 2.9 6.3 6.3 6.3zM61.2 92.9c3.5 0 6.3-2.8 6.3-6.3s-2.8-6.3-6.3-6.3-6.3 2.8-6.3 6.3c.1 3.5 2.9 6.3 6.3 6.3zM30.4 147.2c3.5 0 6.3-2.8 6.3-6.3s-2.8-6.3-6.3-6.3-6.3 2.8-6.3 6.3 2.8 6.3 6.3 6.3zM22.5 177.6c3.5 0 6.3-2.8 6.3-6.3S26 165 22.5 165s-6.3 2.8-6.3 6.3 2.8 6.3 6.3 6.3zM20 208.9c3.5 0 6.3-2.8 6.3-6.3s-2.8-6.3-6.3-6.3-6.3 2.8-6.3 6.3c.1 3.5 2.9 6.3 6.3 6.3zM31.3 270.4c3.5 0 6.3-2.8 6.3-6.3s-2.8-6.3-6.3-6.3-6.3 2.8-6.3 6.3 2.9 6.3 6.3 6.3zM44.9 298.7c3.5 0 6.3-2.8 6.3-6.3s-2.8-6.3-6.3-6.3-6.3 2.8-6.3 6.3 2.8 6.3 6.3 6.3zM63 324.2c3.5 0 6.3-2.8 6.3-6.3s-2.8-6.3-6.3-6.3-6.3 2.8-6.3 6.3c.1 3.5 2.9 6.3 6.3 6.3zM111.2 364c3.5 0 6.3-2.8 6.3-6.3s-2.8-6.3-6.3-6.3-6.3 2.8-6.3 6.3c.1 3.5 2.9 6.3 6.3 6.3zM139.8 377c3.5 0 6.3-2.8 6.3-6.3s-2.8-6.3-6.3-6.3-6.3 2.8-6.3 6.3 2.8 6.3 6.3 6.3zM170.1 385c3.5 0 6.3-2.8 6.3-6.3s-2.8-6.3-6.3-6.3-6.3 2.8-6.3 6.3c.1 3.4 2.9 6.3 6.3 6.3zM232.6 384.5c3.5 0 6.3-2.8 6.3-6.3s-2.8-6.3-6.3-6.3-6.3 2.8-6.3 6.3 2.8 6.3 6.3 6.3zM262.9 376.1c3.5 0 6.3-2.8 6.3-6.3s-2.8-6.3-6.3-6.3-6.3 2.8-6.3 6.3 2.8 6.3 6.3 6.3zM291.1 362.7c3.5 0 6.3-2.8 6.3-6.3s-2.8-6.3-6.3-6.3-6.3 2.8-6.3 6.3c.1 3.5 2.9 6.3 6.3 6.3zM338.7 322.1c3.5 0 6.3-2.8 6.3-6.3s-2.8-6.3-6.3-6.3-6.3 2.8-6.3 6.3 2.8 6.3 6.3 6.3zM356.5 296.3c3.5 0 6.3-2.8 6.3-6.3s-2.8-6.3-6.3-6.3-6.3 2.8-6.3 6.3 2.8 6.3 6.3 6.3zM369.6 267.8c3.5 0 6.3-2.8 6.3-6.3s-2.8-6.3-6.3-6.3-6.3 2.8-6.3 6.3 2.8 6.3 6.3 6.3zM380 206.1c3.5 0 6.3-2.8 6.3-6.3s-2.8-6.3-6.3-6.3-6.3 2.8-6.3 6.3 2.8 6.3 6.3 6.3zM377 174.9c3.5 0 6.3-2.8 6.3-6.3s-2.8-6.3-6.3-6.3-6.3 2.8-6.3 6.3 2.8 6.3 6.3 6.3z"
          />
        </g>
        <g id="loading-outer4">
          <path
            className="st5"
            d="M325.4 56.5c3.5 0 6.3-2.8 6.3-6.3s-2.8-6.3-6.3-6.3-6.3 2.8-6.3 6.3c0 3.4 2.8 6.3 6.3 6.3zM198.7 11.5c3.5 0 6.3-2.8 6.3-6.3s-2.8-6.3-6.3-6.3-6.3 2.8-6.3 6.3c.1 3.4 2.9 6.3 6.3 6.3zM72.8 58.5c3.5 0 6.3-2.8 6.3-6.3s-2.8-6.3-6.3-6.3-6.3 2.8-6.3 6.3c0 3.4 2.9 6.3 6.3 6.3zM6.5 175.4c3.5 0 6.3-2.8 6.3-6.3s-2.8-6.3-6.3-6.3-6.3 2.8-6.3 6.3c.1 3.5 2.9 6.3 6.3 6.3zM30.9 307.5c3.5 0 6.3-2.8 6.3-6.3s-2.8-6.3-6.3-6.3-6.3 2.8-6.3 6.3 2.8 6.3 6.3 6.3zM134.5 393.1c3.5 0 6.3-2.8 6.3-6.3s-2.8-6.3-6.3-6.3-6.3 2.8-6.3 6.3c.1 3.5 2.9 6.3 6.3 6.3zM269 392c3.5 0 6.3-2.8 6.3-6.3s-2.8-6.3-6.3-6.3-6.3 2.8-6.3 6.3 2.8 6.3 6.3 6.3zM371.2 304.8c3.5 0 6.3-2.8 6.3-6.3s-2.8-6.3-6.3-6.3-6.3 2.8-6.3 6.3 2.8 6.3 6.3 6.3zM393.5 172.3c3.5 0 6.3-2.8 6.3-6.3s-2.8-6.3-6.3-6.3-6.3 2.8-6.3 6.3 2.8 6.3 6.3 6.3z"
          />
        </g>
      </svg>
    );
  }
);

const StyledSpinner = styled(Spinner)`
  .st0 {
    fill-rule: evenodd !important;
    clip-rule: evenodd;
    fill: #1363ab;
  }
  .st1 {
    fill: #3d75a1;
  }
  .st2 {
    fill: #1263ab;
  }
  .st3 {
    fill: #73a7da;
  }
  .st4 {
    fill: #9fc8ea;
  }
  .st5 {
    fill: #b6d7f1;
  }

  #loading-innercircle_1_ {
    animation: rotate 0s linear alternate infinite;
    transform-origin: center;
    animation-delay: 0s;
    animation-timing-function: ease-in;
  }

  #loading-outer1 {
    animation: pulse 1s linear alternate infinite;
    animation-delay: 0.15s;
    animation-timing-function: cubic-bezier(0.64, 0, 0.78, 0);
  }

  #loading-outer2 {
    animation: pulse 1s linear alternate infinite;
    animation-delay: 0.3s;
    animation-timing-function: cubic-bezier(0.64, 0, 0.78, 0);
  }

  #loading-outer3 {
    animation: pulse 1s linear alternate infinite;
    animation-delay: 0.45s;
    animation-timing-function: cubic-bezier(0.64, 0, 0.78, 0);
  }

  #loading-outer4 {
    animation: pulse 1s linear alternate infinite;
    animation-delay: 0.6s;
    animation-timing-function: cubic-bezier(0.64, 0, 0.78, 0);
  }

  #loading-outer5 {
    animation: pulse 1s linear alternate infinite;
    animation-delay: 0.75s;
    animation-timing-function: cubic-bezier(0.64, 0, 0.78, 0);
  }

  @-webkit-keyframes pulse {
    0% {
      opacity: 0;
      -webkit-opacity: 0;
    }
    50% {
      opacity: 1;
      -webkit-opacity: 1;
    }
    100% {
      opacity: 1;
      -webkit-opacity: 1;
    }
  }

  @keyframes pulse {
    0% {
      opacity: 0;
      -webkit-opacity: 0;
    }
    50% {
      opacity: 1;
      -webkit-opacity: 1;
    }
    100% {
      opacity: 1;
      -webkit-opacity: 1;
    }
  }

  @-webkit-keyframes rotate {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }

  @keyframes rotate {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;

export default StyledSpinner;
